export const openTopUpBalance = (amount: number) => ({
  action: 'refill-balance',
  payload: { amount },
});
